import { FieldValues, UseFormSetValue } from 'react-hook-form';
import { BaseSlide } from '../../../../../models/slides/BaseSlide';
import { EventSlide } from '../../../../../models/slides/EventSlide';
import { fetchEventForPreview } from '../../../../../services/eventServices/EventPreviewService';
import { getEventSlide } from './getEventSlide';

export const updateEvent = async ({ slide, setValue, index }: { slide: BaseSlide; setValue: UseFormSetValue<FieldValues>; index: number }) => {
  const eventSlide = slide as EventSlide;
  if (!eventSlide.id) setValue(`slideDatas[${index}]`, emptyEvent);

  try {
    const eventElement = (await fetchEventForPreview(eventSlide.id)) as EventSlide;
    const updatedEvent = getEventSlide(eventElement);
    setValue(`slideDatas[${index}]`, updatedEvent);
  } catch (error) {
    console.log(error);
  }
};

export const emptyEvent = { url: '', type: 'EVENT', description: '', title: '', id: 0, dateFrom: null, dateTo: null, organizer: '', location: [], ticketPrices: [], animalFriendly: null, disabledFriendly: null };
